"use strict";
exports.__esModule = true;
exports.makeEmptyFeatureGate = exports.makeFeatureGate = void 0;
function makeFeatureGate(name, ruleID, value, groupName, idType, evaluationDetails) {
    return { name: name, ruleID: ruleID, value: value, groupName: groupName, idType: idType, evaluationDetails: evaluationDetails };
}
exports.makeFeatureGate = makeFeatureGate;
function makeEmptyFeatureGate(name) {
    return {
        name: name,
        ruleID: '',
        value: false,
        groupName: null,
        idType: null,
        evaluationDetails: null
    };
}
exports.makeEmptyFeatureGate = makeEmptyFeatureGate;
